import { render, staticRenderFns } from "./CommonParameters.vue?vue&type=template&id=bce70bd2&scoped=true&lang=html&"
import script from "./CommonParameters.vue?vue&type=script&lang=js&"
export * from "./CommonParameters.vue?vue&type=script&lang=js&"
import style0 from "./CommonParameters.vue?vue&type=style&index=0&id=bce70bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce70bd2",
  null
  
)

export default component.exports